import React, { useState } from "react";
import { Box, Typography, CardMedia } from "@mui/material";
import { db } from "../firebase";
import { verifyTotp, sha256Hex } from "../utils/totp";
import { T } from "./Translate";
import logo from "../imgs/logo192.png";

// Gate de verificación en dos pasos: se muestra en App.js entre el login
// y el resto de la app cuando users/{uid}.twoFactorEnabled === true y esta
// sesión todavía no lo verificó. Acepta un código TOTP de 6 dígitos o un
// código de respaldo (que se consume al usarlo).
const TwoFactorChallenge = ({ user, onSuccess, onCancel }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [verifying, setVerifying] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError("");
    setVerifying(true);
    try {
      const snap = await db.doc(`users/${user.uid}`).get();
      const data = snap.exists ? snap.data() : {};
      const secret = data.twoFactorSecret;
      const backupCodes = Array.isArray(data.twoFactorBackupCodes) ? data.twoFactorBackupCodes : [];

      const trimmed = code.trim();
      const isTotpValid = secret ? await verifyTotp(secret, trimmed) : false;

      if (isTotpValid) {
        onSuccess();
        return;
      }

      const hashedInput = await sha256Hex(trimmed.toUpperCase());
      if (backupCodes.includes(hashedInput)) {
        const remaining = backupCodes.filter((c) => c !== hashedInput);
        await db.doc(`users/${user.uid}`).set({ twoFactorBackupCodes: remaining }, { merge: true });
        onSuccess();
        return;
      }

      setError("Código inválido. Probá con el código de tu app autenticadora o un código de respaldo.");
    } catch (err) {
      setError("Error al verificar el código: " + err.message);
    }
    setVerifying(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        gap: 2,
        textAlign: "center",
      }}
    >
      <CardMedia component="img" image={logo} sx={{ width: 72, height: 72, mb: 1 }} />
      <Typography variant="h6"><T>Verificación en dos pasos</T></Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", maxWidth: 320 }}>
        <T>Ingresá el código de tu app autenticadora, o un código de respaldo si no lo tenés a mano.</T>
      </Typography>
      <form onSubmit={handleVerify} style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "center" }}>
        <input
          type="text"
          autoFocus
          placeholder="000000"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          style={{ padding: 10, borderRadius: 6, border: "1px solid #ccc", width: 200, textAlign: "center", fontSize: 20, letterSpacing: 2 }}
        />
        <button
          type="submit"
          disabled={verifying || !code}
          style={{ color: "white", background: "#1976d2", padding: "10px 24px", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: "bold" }}
        >
          <T>Verificar</T>
        </button>
      </form>
      {error && <Typography color="error" variant="body2">{error}</Typography>}
      <Typography
        variant="body2"
        onClick={onCancel}
        sx={{ color: "text.secondary", textDecoration: "underline", cursor: "pointer", mt: 2 }}
      >
        <T>Cerrar sesión</T>
      </Typography>
    </Box>
  );
};

export default TwoFactorChallenge;
